import { Injectable } from '@angular/core';

@Injectable()
export class DataHelperService {
  isEmptyObject(obj) {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) { return false; }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/shared/data-helper.service.ts